export default "__VITE_ASSET__gaBLOs4e__"